import {Tabs} from "antd";
import {useState} from "react";
import CompanyProductInfo from "../../company/CompanyProductInfo";
import ProductAttributes from "./ProductAttributes";
import ProductCategories from "./ProductCategories";
import ProductRules from "./ProductRules";
import DealerProductInfo from "../../dealer/DealerProductInfo";

type ProductTabsProps = {
    isCreating: boolean
    type: 'dealer' | 'company'
}

const ProductTabs = ({isCreating, type}: ProductTabsProps) => {
    const [activeTab, setActiveTab] = useState<ProductTabsType>('info')

    const tabs: Tab[] = [
        {
            key: 'info',
            label: 'Info',
            children: type === 'company' ? <CompanyProductInfo/> : <DealerProductInfo/>
        },
        {
            key: 'attributes',
            label: "Attributes",
            disabled: isCreating,
            children: <ProductAttributes isHiddenAssetAttributes={type === 'dealer'}/>
        },
        {
            key: 'categories',
            label: "Categories",
            disabled: isCreating,
            children: <ProductCategories/>
        },
        {
            key: 'rules',
            label: "Rules",
            disabled: isCreating,
            children: <ProductRules/>
        }
    ]

    return (
        <Tabs
            defaultActiveKey={activeTab}
            onChange={(key) => setActiveTab(key as ProductTabsType)}
            items={tabs}
        />
    );
};

export default ProductTabs;

type Tab = { key: string, label: string, children: JSX.Element, disabled?: boolean }
type ProductTabsType = 'info' | 'attributes' | 'rules' | 'categories'
